import { CountryCodes, CountryNames } from "./types"

export const workplaceList = [
  { label: 'Remote', value: 'Remote' },
  { label: 'Hybrid', value: 'Hybrid' },
  { label: 'In-Person', value: 'In-Person' }
]

export const jobTypeList = [
  { label: 'Permanent Full-time', value: 'Permanent Full-time' },
  { label: 'Permanent Part-time', value: 'Permanent Part-time' },
  { label: 'Contract Full-time', value: 'Contract Full-time' },
  { label: 'Contract Part-time', value: 'Contract Part-time' },
  { label: 'Internship', value: 'Internship' },
  { label: 'Volunteer', value: 'Volunteer' },
  { label: 'Casual', value: 'Casual' }
]

export const paymentFrequency = [
  { label: 'Hourly', value: 'Hourly' },
  { label: 'Daily', value: 'Daily' },
  { label: 'Bi-weekly', value: 'Bi-weekly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Yearly', value: 'Yearly' }
]

export const countryList = [
  { label: 'Canada', value: CountryCodes.CA },
  { label: 'United States', value: CountryCodes.US },
  { label: 'Outside North America', value: CountryNames.OUTSIDE_NA_SELECT_VALUE }
]

export const filterCountryList = [
  { label: 'Canada', value: CountryNames.CA },
  { label: 'United States', value: CountryNames.US },
  { label: 'Outside North America', value: CountryNames.OUTSIDE_NA_SELECT_VALUE }
]

export const datePosted = [
  {label: 'Last 24 Hours', value: 'Last 24 Hours'}, 
  {label: 'Last Week', value: 'Last Week'},
  {label: 'Last Month', value: 'Last Month'},
]